import React from 'react';
import ErrorBoundary from '../../../shared/error-boundary';

export default function SignInButton() {
  function signIn(event) {
    event && event.preventDefault();
    window.location = '/sign_in';
  }

  return (
    <ErrorBoundary>
      <button
        type="button"
        className="btn btn-secondary sign-in-button"
        onClick={signIn}
      >
        Sign In
      </button>
    </ErrorBoundary>
  );
}
